var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M348.7,424.5c26.3,0,47.9-21.2,48.1-47.5c0-0.2,0-0.3,0-0.5c0-67.3-63.9-121.8-142.8-121.8 s-142.8,54.5-142.8,121.8c0,0.2,0,0.3,0,0.5c0.1,26.3,21.7,47.5,48.1,47.5H348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9984"
    },
    d: "M346.4,208.1c0,0.1,0,0.3,0,0.4c-2.3,33-18.8,63.6-45,83.8c-3,2.3-6.1,4.6-9.3,6.8 c-11,7.5-23.7,14.7-38.1,21.4c-14.4-6.7-27.1-13.9-38.1-21.5c-3.2-2.2-6.3-4.5-9.3-6.8c-26.2-20.2-42.7-50.8-45-83.8V208 c2-17.6,10.7-35.1,26.1-51.5s37.5-31.8,66.3-45.3C311.6,138.2,342.5,172.9,346.4,208.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M292.1,299.1c-11,7.5-23.7,14.7-38.1,21.4c-14.4-6.7-27.1-13.9-38.1-21.5l4.2-41.4H288L292.1,299.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M321.4,202.1c0,50.7-29.9,91.8-66.9,91.8c-33.5,0-61.3-33.8-66.1-78c-0.5-4.5-7.7-9.4-4-36.4 c5.5-39.9,39-69.3,70.1-69.3C291.4,110.3,321.4,151.4,321.4,202.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD05B"
    },
    points: "188.3,215.9 184.7,208.1 188.3,204.1 193,212.1  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M262.1,96.9c2.5,0.8,53.2,2.1,74.3,40.3l-13.3-8.3c0,0,10.3,10.4,11.9,33.9c1,15-1.9,29.9-8.1,43.8 l-6.7,14.9c0,0,2-52.7-9.3-58.6c0,0-8.8,10.8,0,20.8c0,0-27.5-0.5-23.1-37c0,0-38.8-3.7-41.2,33.6c0,0-16.2-0.8-14.2-21.2 c0,0-21.1,1.7-26,24.1c0,0-1.1-13.2-10.3-21.4c0,0-7.2,35.4-7.7,54.1c0,0-53.7-96.9,71.7-119.7C260.8,96.1,261.4,96.6,262.1,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M254,60L254,60c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0l0,0c-51.2,1.3-92.4,61.1-92.4,134.6 c0,4.5,0.2,9,0.5,13.5c3.3-28.6,24.6-56.9,63.8-80.9c17.4-10.7,39.4-10.7,56.8,0c39.2,24,60.5,52.3,63.8,80.9 c0.3-4.4,0.5-8.9,0.5-13.5C346.5,121.1,305.2,61.3,254,60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M348.7,302.4H159.3c-8.4,0-13.8,6.7-12,14.8l21.7,98.4c1.1,5,7.1,8.9,13.5,8.9h142.9 c6.4,0,12.4-3.9,13.5-8.9l21.7-98.4C362.4,309.1,357.1,302.4,348.7,302.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#CED5E0"
    },
    cx: 254,
    cy: 359.6,
    rx: 26.9,
    ry: 12.2
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAvatar);
export default __webpack_public_path__ + "static/media/my-avatar.a62d444691d6b680ab33ba6ab0da6ada.svg";
export { ForwardRef as ReactComponent };